// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../static/images/valuebg4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../static/images/value-banner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.huisebg {
  background: #f2f5fa;
  width: 100%;
  min-width: 1200px;
}
.baise {
  width: 100%;
}
.valueBox {
  width: 1200px;
  margin: 0px auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.valueBox .context {
  width: 55%;
}
.valueBox .context > p {
  font-size: 14px;
  color: #999;
  margin: 0px;
}
.valueBox h3 {
  font-size: 24px;
  margin: 0px;
}
.valueBox .text {
  font-size: 14px;
  line-height: 26px;
  padding-top: 20px;
}
.valueBox .text p {
  margin: 0;
}
.lvyue {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat bottom;
  height: 340px;
  width: 500px;
}
.valueBanner {
  height: 430px;
  min-width: 1200px;
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat top center;
}
.zhishiku {
  display: flex;
  padding-bottom: 30px;
}
.zhishiku h3 {
  font-size: 16px;
  padding-top: 15px;
}
.zhishiku p {
  font-size: 14px;
  color: #555;
  line-height: 26px;
}
.zhishiku .list {
  padding: 0px 25px;
}
.cloudSave {
  display: flex;
  padding-bottom: 30px;
}
.cloudSave h3 {
  font-size: 16px;
  padding-top: 15px;
}
.cloudSave p {
  font-size: 14px;
  color: #555;
  line-height: 26px;
}
.cloudSave .list {
  padding: 0px 25px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AddValue/index.less"],"names":[],"mappings":"AAAA;EAAS,mBAAA;EAAoB,WAAA;EAAY,iBAAA;AAIzC;AAHA;EAAO,WAAA;AAMP;AALA;EAAU,aAAA;EAAc,gBAAA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;AAY7E;AAZA;EACY,UAAA;AAcZ;AAfA;EAES,eAAA;EAAiB,WAAA;EAAY,WAAA;AAkBtC;AApBA;EAIM,eAAA;EAAgB,WAAA;AAoBtB;AAxBA;EAKS,eAAA;EAAgB,iBAAA;EAAmB,iBAAA;AAwB5C;AA7BA;EAMQ,SAAA;AA0BR;AAvBA;EAAO,oEAAA;EAAoE,aAAA;EAAc,YAAA;AA4BzF;AA3BA;EACG,aAAA;EAAc,iBAAA;EAAkB,WAAA;EAAY,wEAAA;AAgC/C;AA9BA;EAAU,aAAA;EAAe,oBAAA;AAkCzB;AAlCA;EACM,eAAA;EAAgB,iBAAA;AAqCtB;AAtCA;EAEK,eAAA;EAAgB,WAAA;EAAY,iBAAA;AAyCjC;AA3CA;EAGS,iBAAA;AA2CT;AAzCA;EACG,aAAA;EAAe,oBAAA;AA4ClB;AA7CA;EAEM,eAAA;EAAgB,iBAAA;AA+CtB;AAjDA;EAGK,eAAA;EAAgB,WAAA;EAAY,iBAAA;AAmDjC;AAtDA;EAIS,iBAAA;AAqDT","sourcesContent":[".huisebg{background:#f2f5fa; width:100%; min-width:1200px; }\n.baise{width:100%;}\n.valueBox{width:1200px; margin:0px auto; display: flex; align-items: center; justify-content: space-between;\n   .context{width:55%;\n      >p{font-size: 14px; color:#999; margin:0px;}\n   }\n   h3{font-size:24px; margin:0px;}\n   .text{font-size:14px; line-height: 26px; padding-top:20px;\n      p{margin: 0;}\n   }\n}\n.lvyue{background: url(../../static/images/valuebg4.png) no-repeat bottom; height:340px; width:500px;}\n.valueBanner{\n   height:430px; min-width:1200px; width:100%; background:url(../../static/images/value-banner.jpg) no-repeat top center;\n}\n.zhishiku{display: flex; padding-bottom:30px;\n   h3{font-size:16px; padding-top:15px;}\n   p{font-size:14px; color:#555; line-height: 26px;}\n   .list{padding:0px 25px;}\n}\n.cloudSave{\n   display: flex; padding-bottom:30px;\n   h3{font-size:16px; padding-top:15px;}\n   p{font-size:14px; color:#555; line-height: 26px;}\n   .list{padding:0px 25px;}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
